/**
 * Shared page header for the routed Document Vault screens: the sticky topbar
 * with the screen title on the left and route-supplied primary actions on the
 * right. Reuses the vault shell's topbar styles so every route matches the
 * original chrome.
 */
import React from "react";
import * as styles from "../styles_vanilla.css";

export type VaultPageHeaderProps = {
  title: string;
  /** Right-aligned primary actions (e.g. Upload, New space). */
  children?: React.ReactNode;
};

export const VaultPageHeader = ({ title, children }: VaultPageHeaderProps) => (
  <header className={styles.topbar}>
    <div>
      <h1 className={styles.title}>{title}</h1>
    </div>
    {children ? <div className={styles.acts}>{children}</div> : null}
  </header>
);
